module.exports = __webpack_public_path__ + "img/PostgreSQL.ab6e77d.svg";